<template>
  <div id="home" class="home"></div>
</template>

<script>
export default {
}
</script>

<style scoped>
.home {
  background-image: url(../assets/covid.jpg);
  height: 60vh;
  background-size: cover;
  background-position: center -16rem;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
</style>